// extracted by mini-css-extract-plugin
export default {"wrapper":"mx-z","response":"nx-z","error":"ox-z","disabled":"px-z","buttons":"qx-z","feedbackQuestionSection":"rx-z","yesNoWrapper":"sx-z"};